let debuggerOn = false;

export function setDebuggerMode(debug) {
  debuggerOn = debug;
}

export function debuggerMode() {
  return debuggerOn;
}



// WEBPACK FOOTER //
// ./debugger.js